/** Every editor command, by group. Adding a command here also needs its params schema (registry test). */
import { ACTION_COMMANDS } from './actions';
import { DOCUMENT_COMMANDS } from './document';
import { FILTER_COMMANDS } from './filters';
import { RESOURCE_COMMANDS } from './resources';
import { PAINT_COMMANDS } from './paint';
import { SELECTION_COMMANDS } from './selection';
import { SMART_COMMANDS } from './smart';
import { TEXT_COMMANDS } from './text';
import { VECTOR_APPEARANCE_COMMANDS } from './vector-appearance';
import { VECTOR_OBJECT_COMMANDS } from './vector-objects';
import { createCommandRegistry, type CommandRegistry, type EditorCommand } from './registry';

export const EDITOR_COMMANDS: readonly EditorCommand[] = [
  ...DOCUMENT_COMMANDS,
  ...FILTER_COMMANDS,
  ...RESOURCE_COMMANDS,
  ...SELECTION_COMMANDS,
  ...PAINT_COMMANDS,
  ...TEXT_COMMANDS,
  ...SMART_COMMANDS,
  ...ACTION_COMMANDS,
  ...VECTOR_APPEARANCE_COMMANDS,
  ...VECTOR_OBJECT_COMMANDS,
];

let registry: CommandRegistry | null = null;

export function editorCommands(): CommandRegistry {
  registry ??= createCommandRegistry(EDITOR_COMMANDS);
  return registry;
}
